import { DataSource, Layout, Map } from "@mcleod/components";

export abstract class AutogenLayoutMovementMap extends Layout {
    mapStatus: Map;
    sourceMapData: DataSource;
}
